import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import WarrantyForm from './form';
import WarrantyService from '../../services/warranty-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const service = WarrantyService;

  const getErrors = values => {
    const errors = {};
    const minimumValues = { code: values.code, name: values.name };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    return errors;
  };

  return {
    getErrors,
    service,
    keyName: 'code'
  };
};

export default withStyles(styles)(EditForm(Edit)(WarrantyForm));
